import { render, staticRenderFns } from "./TabContentLeaderboard.vue?vue&type=template&id=7c0897fe&scoped=true"
import script from "./TabContentLeaderboard.vue?vue&type=script&lang=js"
export * from "./TabContentLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./TabContentLeaderboard.vue?vue&type=style&index=0&id=7c0897fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0897fe",
  null
  
)

export default component.exports